import React from "react";
import ReactDOMServer from "react-dom/server";
import { Modal, Button } from "react-bootstrap";
import StockDocumentPreview from "./StockDocumentPreview";

// Live preview (react-bootstrap Modal, same as CustomerSitesPanel.jsx) +
// real Print action. Print reuses this project's established popup pattern
// (qrImageUtils.js's printComposedImage: window.open("", "_blank") -> write
// HTML -> window.print()) rather than adding a PDF/print npm dependency -
// the popup's content is generated from the SAME <StockDocumentPreview>
// component via ReactDOMServer.renderToStaticMarkup, so there is exactly one
// template to maintain, not one for preview and a second for print.
//
// `copies` (LPO only) prints CUSTOMER COPY then OFFICE COPY back to back,
// matching the two-page sample PDF, with a page-break between them.
const StockDocumentPrintModal = ({ show, onClose, docProps, copies = 1 }) => {
  const copyLabels = copies === 2 ? ["CUSTOMER COPY", "OFFICE COPY"] : [null];

  const handlePrint = () => {
    const bodyHtml = copyLabels
      .map(
        (copyLabel, idx) =>
          `<div style="${idx > 0 ? "page-break-before: always;" : ""}">${ReactDOMServer.renderToStaticMarkup(
            <StockDocumentPreview {...docProps} copyLabel={copyLabel} />
          )}</div>`
      )
      .join("");

    const win = window.open("", "_blank", "width=900,height=1000");
    if (!win) return;
    win.document.write(
      `<html><head><title>${docProps.title} - ${docProps.docNo}</title>` +
        // A4 paper, not the browser's default page size - margin here plus
        // the template's own 16px padding is what actually meets the paper
        // edge; body width capped to the printable A4 area (210mm minus
        // margins) so the layout paginates the same on screen and on paper.
        `<style>@page { size: A4; margin: 10mm; } html,body { margin:0; padding:0; } body { width: 190mm; }</style>` +
        `</head>` +
        `<body onload="window.print();window.close();">${bodyHtml}</body></html>`
    );
    win.document.close();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>Print Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: "#e9ecef" }}>
        {copyLabels.map((copyLabel, idx) => (
          <div key={idx} className="mb-3" style={{ border: "1px solid #ccc" }}>
            <StockDocumentPreview {...docProps} copyLabel={copyLabel} />
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
        <Button variant="primary" onClick={handlePrint}>Print</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StockDocumentPrintModal;
